import React, { Component } from 'react';
import { connect } from 'react-redux';
import Datatable from '../../../../components/common/datatable/index';

class PipEposObjectivesTable extends Component {
  // eslint-disable-next-line class-methods-use-this
  render() {
    const { pipEposObjectives } = this.props;
    const columns = [
      {
        prop: 'name',
        title: 'Objective name'
      },
      {
        prop: 'start-date',
        title: 'Start date'
      },
      {
        prop: 'end-date',
        title: 'End date'
      },
      {
        prop: 'outlet-count',
        title: 'Outlet count'
      }
    ];

    return (
      <div>
        <div className="mg-bottom-30"></div>
        <Datatable
          hideId={false}
          data={pipEposObjectives || []}
          columns={columns}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pipEposObjectives: state.pipEposObjectives.pipEposObjectives
});

export default connect(mapStateToProps)(PipEposObjectivesTable);
